import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import Forms from './Forms'
import { Row, Col } from 'antd'
import { Redirect } from 'react-router-dom'
import Breadcrumb from './../../../shared/components/Breadcrumbreport'
import { GeneralStyledContent } from '../../../../styled/common-styled'
import AuthorizeComponent from './../../../auth/components/AuthorizeComponent'

class Index extends Component {
  loadBehaviordriving = (values, loading) => {
    values = {
      ...values,
      type_file: 'excel',
    }
    this.props.loadBehaviordriving(values, loading)
  }

  loadVehicle = (vehicletypeID, loading_vehicle) => {
    this.props.loadVehicle(vehicletypeID, loading_vehicle)
  }

  render() {
    const { vehicleLists, behaviordrivingLoading } = this.props.behaviordriving
    return (
      <AuthorizeComponent {...this.props} matching_name="BehaviordrivingReport">
        <GeneralStyledContent>
          <Row gutter={24}>
            <Col span={24}>
              {/* <Breadcrumb
                match={this.props.match}
                sub_menu="behavior"
                style={{ margin: '0px 0px 14px 10px' }}
              /> */}
            </Col>
          </Row>
          <Forms
            onSubmit={this.loadBehaviordriving}
            vehicleLists={vehicleLists}
            behaviordrivingLoading={behaviordrivingLoading}
            loadVehicle={this.loadVehicle}
            auth={this.props.profile}
          />
        </GeneralStyledContent>
      </AuthorizeComponent>
    )
  }
}

const mapStateToProps = ({ behaviordriving, auth: { profile } }) => ({
  behaviordriving,
  profile,
})

const mapDispatchToProps = {
  loadBehaviordriving: actions.loadBehaviordriving.request,
  loadVehicle: actions.loadVehicle.request,
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
